import React from 'react';


export default function Section({ __typename: type, ...props }) {
    let SectionComponent = () => <div> -- Section {type} not found -- </div>;

    switch (type) {
        case 'DatoCmsHeroSection':
            SectionComponent = require('./components/HeroSection').default;
            break;
        case 'DatoCmsLogosSection':
            SectionComponent = require('./components/LogosSection').default;
            break;
        case 'DatoCmsNumbersSection':
            SectionComponent = require('./components/NumbersSection').default;
            break;
        case 'DatoCmsFeatureSection':
            SectionComponent = require('./components/FeatureSection').default;
            break;
        case 'DatoCmsPointsSection':
            SectionComponent = require('./components/PointsSection').default;
            break;
        case 'DatoCmsCtaSection':
            SectionComponent = require('./components/CtaSection').default;
            break;
        case 'DatoCmsTestimonialsSection':
            SectionComponent = require('./components/TestimonialsSection')
                .default;
            break;
        case 'DatoCmsHeroFormSection':
            SectionComponent = require('./components/HeroFormSection').default;
            break;
        case 'DatoCmsSpacerSection':
            SectionComponent = require('./components/SpacerSection').default;
            break;
        case 'DatoCmsTextSection':
            SectionComponent = require('aplazame-design-system').TextSection;
            break;
        case 'DatoCmsStoresSection':
            SectionComponent = require('./components/StoresSection').default;
            break;
        case 'DatoCmsProductsSection':
            SectionComponent = require('./components/ProductsSection').default;
            break;
        case 'DatoCmsOffersSection':
            SectionComponent = require('./components/OffersSection').default;
            break;
        case 'DatoCmsFaqSection':
            SectionComponent = require('./components/FaqSection').default;
            break;
        case 'DatoCmsContentSection':
            SectionComponent = require('./components/ContentSection').default;
            break;
        case 'DatoCmsTabSection':
            SectionComponent = require('./components/TabSection').default;
            break;
        case 'DatoCmsButtonSection':
            SectionComponent = require('./components/ButtonSection').default;
            break;
        case 'DatoCmsPricingSection':
            SectionComponent = require('./components/PricingSection').default;
            break;
        case 'DatoCmsPricingTabsSection':
            SectionComponent = require('./components/PricingTabsSection')
                .default;
            break;
        case 'DatoCmsCollectionsSection':
            SectionComponent = require('./components/CollectionsSection')
                .default;
            break;
        case 'DatoCmsStoreCategoriesSection':
            SectionComponent = require('./components/StoreCategoriesSection')
                .default;
            break;
        case 'DatoCmsPluginsSection':
            SectionComponent = require('./components/PluginsSection').default;
            break;
        case 'DatoCmsWordpressPostsSection':
            SectionComponent = require('./components/WordpressPostsSection')
                .default;
            break;
        case 'DatoCmsHeaderSection':
            SectionComponent = require('./components/HeaderSection').default;
            break;
        case 'DatoCmsHeaderBlogSubpageSection':
            SectionComponent = require('./components/HeaderBlogSubpageSection')
                .default;
            break;
        case 'DatoCmsHeroAuthorSection':
            SectionComponent = require('./components/HeroAuthorSection')
                .default;
            break;
        case 'DatoCmsWebinarsSection':
            SectionComponent = require('./components/WebinarsSection').default;
            break;
        case 'DatoCmsGuidesSection':
            SectionComponent = require('./components/GuidesSection').default;
            break;
        case 'DatoCmsHeaderResourcesSection':
            SectionComponent = require('./components/HeaderResourcesSection')
                .default;
            break;
        case 'DatoCmsWebinarsHomeSection':
            SectionComponent = require('./components/WebinarsHomeSection')
                .default;
            break;
        case 'DatoCmsGuidesHomeSection':
            SectionComponent = require('./components/GuidesHomeSection')
                .default;
            break;
        case 'DatoCmsEventsHomeSection':
            SectionComponent = require('./components/EventsHomeSection')
                .default;
            break;
        case 'DatoCmsEventsSection':
            SectionComponent = require('./components/EventsSection').default;
            break;
        case 'DatoCmsClientStoriesHomeSection':
            SectionComponent = require('./components/ClientStoriesHomeSection')
                .default;
            break;
        case 'DatoCmsClientStoriesSection':
            SectionComponent = require('./components/ClientStoriesSection')
                .default;
            break;
        case 'DatoCmsTeamSection':
            SectionComponent = require('./components/TeamSection').default;
            break;
        case 'DatoCmsViterbitJobsSection':
            SectionComponent = require('./components/ViterbitJobsSection')
                .default;
            break;
        case 'DatoCmsHelpCategoriesSection':
            SectionComponent = require('./components/HelpCategoriesSection')
                .default;
            break;
        case 'DatoCmsVideoStoriesSection':
            SectionComponent = require('./components/VideoStoriesSection')
                .default;
            break;
        case 'DatoCmsHeroVideo':
            SectionComponent = require('./components/HeroSectionVideo').default;
            break;
        case 'DatoCmsHeroStyle2':
            SectionComponent = require('./components/HeroStyle2Section')
                .default;
            break;
        case 'DatoCmsValueProSection':
            SectionComponent = require('./components/ValueProSection').default;
            break;
        case 'DatoCmsCarouselStoreSection':
            SectionComponent = require('./components/CarouselSection').default;
            break;
        case 'DatoCmsStepsSection':
            SectionComponent = require('./components/StepsSection').default;
            break;
        case 'DatoCmsCarouselCategoriesSection':
            SectionComponent = require('./components/FlipCarousel').default;
            break;
        case 'DatoCmsScrollableSection':
            SectionComponent = require('./components/ScrollableSection')
                .default;
            break;
        case 'DatoCmsBlockTextWithImageSection':
            SectionComponent = require('./components/BlockTextImageSection')
                .default;
            break;
        case 'DatoCmsBlockTextWithImageSectionV2':
            SectionComponent = require('./components/BlockTextImageSectionV2')
                .default;
            break;
        case 'DatoCmsCalculator':
            SectionComponent = require('./components/WrapperCalculator')
                .default;
            break;
        case 'DatoCmsFeaturePointsSection':
            SectionComponent = require('./components/FeaturePointsSection')
                .default;
            break;
        case 'DatoCmsFeaturePointsAlternativeSection':
            SectionComponent = require('./components/FeaturePointsAlternativeSection')
                .default;
            break;
        case 'DatoCmsFavoriteProductsSection':
            SectionComponent = require('./components/FavoriteProductsSection').default;
            break;
        case 'DatoCmsBlockImageWithVideo':
            SectionComponent = require('./components/BlockImageWithVideo').default;
            break;
        default:
            break;
    }
    return (
        <SectionComponent {...props} />
    );
}
